import React from 'react';
import { MemoryRouter, Route, Switch } from 'react-router-dom';

import InvoiceSearchForm from './InvoiceSearchForm';
import InvoiceResultDisplay from './InvoiceResultDisplay';
import { InvoicePaths } from '../../app/enums/InvoicePaths';
import DateInvoiceResultsDisplay from './DateInvoiceResultsDisplay';
import InvoiceTransactionHistory from './InvoiceTransactionHistory';

const getInvoiceRoutes = onClose => [
  {
    path: InvoicePaths.SEARCH,
    component: InvoiceSearchForm,
    render: routeProps => (
      <InvoiceSearchForm {...routeProps} onClose={onClose} />
    ),
  },
  {
    path: InvoicePaths.DETAIL,
    component: InvoiceResultDisplay,
  },
  {
    path: InvoicePaths.DATE_RESULTS,
    component: DateInvoiceResultsDisplay,
  },
  {
    path: InvoicePaths.TRANSACTION_HISTORY,
    component: InvoiceTransactionHistory,
  },
];

export default function InvoiceLookupContent({ onClose }) {
  return (
    <MemoryRouter initialEntries={[InvoicePaths.SEARCH]}>
      <Switch>
        {getInvoiceRoutes(onClose).map(
          ({ path, component: Component, render }) => (
            <Route
              key={path}
              path={path}
              render={routeProps =>
                render ? render(routeProps) : <Component {...routeProps} />
              }
            />
          )
        )}
      </Switch>
    </MemoryRouter>
  );
}
